import HiringQuery from 'apps/hiring/util/query';
import { resolve } from 'library/helpers/path-resolver';

const completedAssessmentsQuery =  (params={}) => (
  HiringQuery(`
    {
    organization {
      id,
      completed_assessments: users(${params.search ? (`name: "${params.search}",`): ``}limit: 1000, has_surveyed: true) {
        results {
          name,
          email,
          id,
          assessment(completed: true) {
            id,
            validity_score,
            validity_errors,
            scored,
          }
        }
      }
    }
  }
  `)
);
const completedAssessmentsParseQuery = (data) => ({
  completed_assessments: resolve(data, 'organization/completed_assessments/results', []),
});

export { completedAssessmentsQuery, completedAssessmentsParseQuery };
